import { DonationList, DonationCreate, DonationEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        DonationList,
        DonationCreate,
        DonationEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'donation',
    icon: 'fa-heart',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Donation/index.ts